import { Component } from '@angular/core';

@Component({
  selector: 'app-te-domain-ext',
  templateUrl: './te-domain-ext.component.html',
  styleUrls: ['./te-domain-ext.component.css']
})
export class TeDomainExtComponent {

}
